<template>
	<div class="wrapper introduce-wrapper">
		<header>
			<TheHeaderBar :title="'退款详情'" />
		</header>
		<div class="content">
			<div style="clear: both;"></div>
			<div class="item item-img" style="padding-left:20px;">
				<span style="color:#323233;font-size:15px;">退款状态</span>
				<span v-if="datas.status == '待审核'" style="color: #323233;margin-left:30px;">{{datas.status}}</span>
				<span v-if="datas.status == '已通过'" style="color: green;margin-left:30px;">{{datas.status}}</span>
				<span v-if="datas.status == '已拒绝'" style="color: red;margin-left:30px;">{{datas.status}}</span>
			</div>
			<div class="item item-img" style="padding-left:5px;">
				<van-field
					  v-model="datas.amount"
					  name="退款金额"
					  label="退款金额"
					  disabled
					/>
			</div>
			<div class="item item-img" style="padding-left:5px;">
				<van-field
					  v-model="datas.title"
					  name="退款原因"
					  label="退款原因"
					  disabled
					/>
			</div>
			<div class="item item-img" style="padding-left:5px;">
				<van-field
					  v-model="datas.name"
					  name="联系人"
					  label="联系人"
					  disabled
					/>
			</div>
			<div class="item item-img" style="padding-left:5px;">
				<van-field
					  v-model="datas.tel"
					  name="联系手机号"
					  label="联系手机号"
					  disabled
					/>
			</div>
			<div style="clear: both;"></div>
			<div class="item item-img">
				<div class="title">凭证图片:</div>
				<div class="send-img-box">
					<img style="width: 100%;" :src="datas.img">
				</div>
			</div>
		</div>

		<footer class="footer">
			<p style="display: flex;align-items:center;padding: 0 0">
				<van-icon name="info-o" color="#f30" />&nbsp;&nbsp;审核成功后，退款会自动退到您的微信账户
			</p>
		</footer>
	</div>
</template>

<script>
	import TheHeaderBar from "../../components/base/TheHeaderBar";
	import {
		refundDetailService
	} from '../../service/userService';
	import {
		Toast,
		Dialog,
		Picker
	} from "vant";
	import {
		mapState
	} from "vuex";
	import {
		wecharShare
	} from "../../util/weChat.js";
	import Vue from 'vue';
	Vue.use(Picker);
	export default {
		name: "Shopaddvideolive",
		data() {
			return {
				datas: [],
				id: 0
			}
		},
		watch: {

		},
		mounted() {
			this.id = this.$route.params.id;
			this.getData();
		},
		methods: {
			getData(){
				refundDetailService(this.id).then(res => {
				    if(res.status === 1){
				        this.datas = res.datas;
				    }else{
				        Toast(res.msg);
				    }
				}).catch(err => {
				    console.log(err);
				}).finally(() => {})
			}
		},
		computed:{
		    ...mapState({
		        userId: state => state.userInfo.userId,
		        openid: state => state.userInfo.openId,
		    })
		},
		components: {
			TheHeaderBar,
		}
	}
</script>

<style scoped lang="scss">
	.wrapper {
		background-color: #ffffFF !important;

		header {
			padding-bottom: 46px;
		}

		.content {
			background-color: #ffffFF !important;

			.steps-box {
				background: linear-gradient(180deg, rgba(254, 141, 123, 1) 0%, rgba(245, 84, 91, 1) 100%)
			}

			.item-text {
				background-color: #FFFFFF;

				.title {
					font-size: 14px;
					color: #202020;
					padding: 20px 20px 10px 20px;
					// box-sizing: border-box;	
				}

				.txt-box {
					padding: 0 20px 10px 20px;
					box-sizing: border-box;
					display: flex;
					align-items: baseline;
				}

				.size-num-box {
					padding: 5px 20px;
					text-align: right;
				}
			}

			.item-img {
				background: #ffffff;

				.title {
					font-size: 14px;
					padding: 10px 20px 10px 20px;
					// box-sizing: border-box;
				}

				.send-img-box {
					padding: 0 20px 10px 20px;
					box-sizing: border-box;
				}
			}
		}

		.footer {
			padding: 10px;
			box-sizing: border-box;
			text-align: center;
		}

		.listactive {
			background-color: #00BFFF;
			color: #fff;
		}
		
		.myvideo{
			width: 100%;
			text-align: center;
			height: 100px;
			color: blue;
		}
	}
</style>
<style>
	.introduce-wrapper .van-steps {
		background-color: transparent;
	}

	.introduce-wrapper .van-step--horizontal .van-step__circle-container {
		background-color: transparent;
	}

	.introduce-wrapper .van-step__title {
		color: #ffffFF;
	}

	.introduce-wrapper .van-step--finish .van-step__circle,
	.van-step--finish .van-step__line {
		background-color: #FFFFFF;
	}

	.introduce-wrapper .txt-box .van-cell {
		padding: 0 0 0 5px;
	}

	.introduce-wrapper .van-uploader {
		width: 100%;
	}

	.introduce-wrapper .van-uploader__upload {
		width: 100%;
	}

	.introduce-wrapper .van-uploader__upload-icon {
		color: rgba(254, 141, 123, 1);
	}

	.introduce-wrapper .van-uploader__preview-image {
		width: 100%;
		height: 100%;
	}

	.introduce-wrapper .van-uploader__preview {
		width: 100%;
	}
</style>
